import { render, staticRenderFns } from "./RegisteredAddress.vue?vue&type=template&id=6f4da428&scoped=true"
import script from "./RegisteredAddress.vue?vue&type=script&lang=js"
export * from "./RegisteredAddress.vue?vue&type=script&lang=js"
import style0 from "./RegisteredAddress.vue?vue&type=style&index=0&id=6f4da428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4da428",
  null
  
)

export default component.exports